exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-content[data-v-2268c9a9]{padding-top:20px!important}.chat-body .header[data-v-2268c9a9]{font-size:20px;font-weight:700;text-align:left;color:#5f6468}@media (max-width:414px){.chat-content[data-v-2268c9a9]{padding-top:30px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2268c9a9","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Chat/index.vue
// module id = 1040
// module chunks = 0